module.exports.app_id = "Dieet.Club";

module.exports.api_url = "https://api.dieet.club";
module.exports.api_token = "Ad1C8hR0F6A3RRJj";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://localhost:3001";
	module.exports.api_token = "123";
}



// WEBPACK FOOTER //
// ./src/config.js